import React from 'react';
import CloudFeederScorePanel from './CloudFeederScorePanel';

const MenuAlarmAttention = (props) => (
  <CloudFeederScorePanel {...props} mode="attention" />
);

export default MenuAlarmAttention;
